let PortfolioButton = () => {
    return(
        <>
            <a href="https://664b18620d17a888095c3231--nimble-narwhal-89fa30.netlify.app/">
            <button style={{backgroundColor: "black", color: "yellow", marginLeft: "10px", marginTop: "20px", scale: "1", borderRadius: "10px", paddingLeft: "10px", paddingRight: "10px"}}>Portfolio Manager</button>
            </a>
        </>
    )
}

export default PortfolioButton;